// The tracking compass every tribute carries, like the LBSG servers handed out.
// The client works it out from the snapshots it already has: no extra traffic.

export interface Tracked {
  id: number;
  name: string;
  x: number;
  z: number;
}

/** The closest of `others` to (x, z), by distance along the ground. */
export function nearestPlayer<T extends Tracked>(x: number, z: number, others: Iterable<T>): { p: T; dist: number } | null {
  let best: { p: T; dist: number } | null = null;
  for (const p of others) {
    const dist = Math.hypot(p.x - x, p.z - z);
    if (!best || dist < best.dist) best = { p, dist };
  }
  return best;
}

/**
 * Where the needle points, in radians clockwise from straight up on the icon,
 * for someone at (x, z) facing `yaw`: up means dead ahead.
 */
export function needleAngle(x: number, z: number, yaw: number, tx: number, tz: number): number {
  const toward = Math.atan2(-(tx - x), -(tz - z)); // the yaw that would face the target
  const a = yaw - toward;
  return Math.atan2(Math.sin(a), Math.cos(a));
}
